var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.iconComponent,{tag:"component",staticClass:"brandhub-icon",attrs:{"width":_vm.iconWidth,"height":_vm.iconHeight,"title":_vm.iconTitle}})}
var staticRenderFns = []

export { render, staticRenderFns }